import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import React, { useCallback, useContext } from 'react';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error untyped module

import ThemeDetailsUsageTrackerContext from '../../context/ThemeDetailsUsageTrackerContext';
import { getDetailsPageShortUrl } from '../../utils/urls';

function ThemeSignInButton(_ref) {
  let {
    onClick,
    section,
    slug
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["onClick", "section", "slug"]);

  const {
    trackBeforeUnloadInteraction
  } = useContext(ThemeDetailsUsageTrackerContext);
  const lang = getLang();
  const detailsPageShortLink = getDetailsPageShortUrl(lang, slug);
  const handleClick = useCallback(evt => {
    trackBeforeUnloadInteraction('click sign in cta button', {
      section
    });
    if (onClick) onClick(evt);
  }, [onClick, section, trackBeforeUnloadInteraction]);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
    href: detailsPageShortLink,
    onClick: handleClick,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.signInButton"
    })
  }));
}

export default ThemeSignInButton;